<template>
  <div class="hospital content-continer" :style="{minHeight:minheight + 'px'}">
    <!-- 管理员 -->
    <!-- <div class="base-content menas">
      <p class="title blue">管理员</p>
      <el-row :gutter="20">
        <el-col :span="6">
          <span class="sed-title">姓名</span>
          {{personlist.adminName}}
        </el-col>
        <el-col :span="6">
          <span class="sed-title">电话</span>
          {{personlist.adminMobile}}
        </el-col>
        <el-col :span="12" style="text-align:right;">
          <el-button type="text" @click="dialogVisible = true">
            <i class="el-icon-edit-outline sed-title"></i>编辑
          </el-button>
        </el-col>
      </el-row>
    </div> -->
    <!-- 搜索 -->
    <div class="base-content menas continer-top">
      <el-row :gutter="20">
        <el-col :span="8">
          <span>用户名字</span>
          <input type="text" placeholder="请输入用户名字" v-model="p" />
        </el-col>
        <el-col :span="13">
          <span>负责科室</span>
          <el-select v-model="specialtyvalue" placeholder="请选择科室名称" @change="specialchange">
            <el-option
              v-for="item in specialtylist"
              :key="item.specId"
              :label="item.specName"
              :value="item.specId"
            ></el-option>
          </el-select>
          <el-select v-model="speciality" placeholder="请选择科室名称" value-key="specId">
            <el-option
              v-for="item in specialty2"
              :key="item.specId"
              :label="item.specName"
              :value="item"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="2" style="text-align:right;">
          <div class="grid-content bg-purple">
            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 用户列表 -->
    <div class="base-content continer-title">
      <div class="blue left" style="margin-top:-10px;">账号列表</div>
      <p class="buit-btn right" style="margin-top:-15px;" @click="dialogVisible2 = true">
        <img src="../assets/hospital-img/add.png" />新增账号
      </p>
    </div>
    <div class="base-content" v-for="(item,index) in personlists" :key="index">
      <p style="margin-bottom:20px;">
        <a class="list-num">{{index+1}}</a>
        <a class="list-name">{{item.cnName?item.cnName:'管理员'}}</a>
      </p>
      <el-row :gutter="20" class="list-msg">
        <el-col :span="6">
          <span class="sed-title">联系电话</span>
          {{item.mobile}}
        </el-col>
        <el-col :span="16">
          <span class="sed-title">负责科室</span>
          {{item.specialtyName?item.specialtyName:'暂无'}}
        </el-col>
        <el-col :span="1">
          <el-button type="text" @click="updata(item.id,item.cnName)">
            <i class="el-icon-edit-outline sed-title"></i>编辑
          </el-button>
        </el-col>
      </el-row>
      <!-- <div class="center" style="margin-top:50px;" v-if="personlists = ''">暂无数据</div> -->
    </div>

    <!-- 管理员信息 -->
    <el-dialog title="管理员修改" :visible.sync="dialogVisible" width="530px" center>
      <form class="forms grid-content">
        <!-- <p><span>姓名</span><input type="text" placeholder="输入姓名"></p> -->
        <p>
          <span>电话</span>
          <input type="text" placeholder="输入手机号" v-model="addmobile" />
        </p>
        <p>
          <span>验证码</span>
          <input type="text" class="code" placeholder="输入验证码" v-model="smsCode" />
          <a class="codebtn" @click="send">获取验证码</a>
        </p>
      </form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="edittel">确 定</el-button>
      </span>
    </el-dialog>

    <!--新增修改管理员信息-->
    <el-dialog 
      title="新增账号信息" 
      :visible.sync="dialogVisible2" 
      width="630px" 
      center
      :before-close ="addCountCancel" 
      >
      <form class="forms grid-content">
        <p>
          <span>姓名</span>
          <input type="text" placeholder="输入姓名" v-model="addName" />
        </p>
        <p>
          <span>电话</span>
          <input type="text" placeholder="输入手机号" v-model="addmobile" />
        </p>
        <p>
          <span>验证码</span>
          <input type="text" class="code" placeholder="输入验证码" v-model="smsCode" />
          <a class="codebtn" @click="send" v-if="Verification">获取验证码</a>
          <a class="codebtn nobtn" v-if="!Verification" style="width:105px">{{time}}s后重新获取</a>
        </p>
        <p>
          <span>负责科室</span>
          <el-select v-model="specialtyvalue" placeholder="请选择专业名称" @change="specialchange">
            <el-option
              v-for="item in specialtylist"
              :key="item.specId"
              :label="item.specName"
              :value="item.specId"
            ></el-option>
          </el-select>
          <el-select v-model="speciality" placeholder="请选择专业名称" value-key="specId">
            <el-option
              v-for="item in specialty2"
              :key="item.specId"
              :label="item.specName"
              :value="item"
            ></el-option>
          </el-select>
        </p>
        <p>
          <span>密码</span>
          <input type="password" placeholder="输入密码" v-model="addpassword" />
        </p>
        <p>
          <span>确认密码</span>
          <input type="password" placeholder="请确认密码" v-model="addpassword2" />
        </p>
      </form>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible2 = false">取 消</el-button> -->
        <el-button @click="addCountCancel">取 消</el-button>
        <el-button type="primary" @click="add">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改管理员信息 -->
    <el-dialog title="修改管理员信息" :visible.sync="dialogVisible3" width="630px" center>
      <form class="forms grid-content">
        <p>
          <span>姓名</span>
          <input type="text" placeholder="输入姓名" v-model="editcnName" />
        </p>
        <p>
          <span>负责科室</span>
          <el-select v-model="specialtyvalue" placeholder="请选择专业名称" @change="specialchange">
            <el-option
              v-for="item in specialtylist"
              :key="item.specId"
              :label="item.specName"
              :value="item.specId"
            ></el-option>
          </el-select>
          <el-select v-model="speciality2" placeholder="请选择专业名称" value-key="specId">
            <el-option
              v-for="item in specialty2"
              :key="item.specId"
              :label="item.specName"
              :value="item"
            ></el-option>
          </el-select>
        </p>
        <p>
          <span>密码</span>
          <input type="password" placeholder="输入密码" v-model="editpassword" />
        </p>
        <p>
          <span>确认密码</span>
          <input type="password" placeholder="请确认密码" v-model="editpassword2" />
        </p>
      </form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="updata1">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { hospitaManagement } from "@/request/api";
import { getSpecialty } from "@/request/api";
import { addManagement } from "@/request/api";
import { getSmsCode2 } from "@/request/api";
import { updata1 } from "@/request/api";
import { subAccountInfo } from "@/request/api";
import { editManagementmsg } from "@/request/api";

import Cookies from "js-cookie";

export default {
  data() {
    return {
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false,
      userId: "",
      cnName: "", //管理员名称
      personlist: "",
      personlists: "",
      specialtylist: [], //专业一级菜单
      specialty2: [], //专业二级菜单
      specialtyvalue: "", //专业一级选中项
      speciality: "", //专业二级菜单选中项
      addName: "", //新增管理员姓名
      addmobile: "", //新增管理员手机号
      addpassword: "", //新增管理员密码
      addpassword2: "", //新增管理员确认密码
      smsCode: "", //新增短信验证码
      addspecialtyId: "", //新增专业名称id
      addspecialtyName: "", //新增专业名称
      minheight: this.Common.minheight,
      mobile: "",
      id: "",
      p: "",
      shujuid: "",
      Verification: true,
      time: 60,
      auth_timer: null,
      editpassword: "",
      editpassword2: "",
      speciality2: "",
      editcnName: "",
      edituserId: ""
    };
  },
  methods: {

    // 新增账号点击取消的处理的处理
    addCountCancel(){
      this.dialogVisible2 = false;
      this.Verification = true;
      if(this.this.auth_timer){
        clearInterval(this.this.auth_timer);
      }
      this.time = 60;
    },

    hospitaManagement() {
      let data = {
        cnName: this.cnName,
        specialityName: this.speciality.specName,
        userId: this.userId
      };
      console.log(data);
      hospitaManagement(data)
        .then(res => {
          console.log(res.data.data);
          this.personlist = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 搜索相关的验证处理
    checkhospitaManagement() {
      if (this.cnName) {
        if (
          /^[0-9]+\.{0,1}[0-9]{0,2}$/.test(this.cnName) ||
          /^[`~!@#$^&*()=|{}':;',\\\[\]\.<>\/?~！@#￥……&*（） ——|{}【】'；：""'。，、《》？\s]+$/.test(
            this.cnName
          )
        ) {
          this.$message.error = "姓名不合法，请重新输入";
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    btn() {
      let data = {
        cnName: this.p,
        // specialityName: this.speciality.specName,
        userId: this.userId
      };
      console.log(data);
      subAccountInfo(data)
        .then(res => {
          console.log(res.data.data);
          this.personlists = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 搜索
    search() {
      // if(!this.checkhospitaManagement()){
      //   console.log("验证不通过");
      // }else{
      //   let data = {
      //     cnName: this.p,
      //     specialityName: this.speciality.specName,
      //     userId: this.userId
      //   }
      //   console.log(data)
      //   hospitaManagement(data).then((res) => {
      //     console.log(res.data.data);
      //     this.personlist = res.data.data;
      //   }).catch((err) => {
      //     console.log(err)
      //   })
      // }
      this.btn();
      console.log(this.personlist);
    },
    // 新增项目专业选择
    specialchange() {
      getSpecialty(this.specialtyvalue)
        .then(res => {
          this.specialty2 = res.data.data;
          this.specialityId = "";
          console.log(this.specialty2);
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 修改手机号
    edittel() {
      let data = {
        code: this.smsCode,
        mobile: this.addmobile,
        userId: this.userId
      };
      telEait(data)
        .then(res => {
          this.$message({
            message: res.data.message,
            type: "success"
          });
          this.smsCode = "";
          this.dialogVisible = false;
          this.addmobile = "";
          this.companyManagement();
        })
        .catch(err => {
          console.log(err);
        });
    },
    //新增管理员人员
    add() {
      let data = {
        cnName: this.addName,
        mobile: this.addmobile,
        password: this.addpassword,
        password2: this.addpassword2,
        smsCode: this.smsCode,
        specialtyId: this.speciality.specId,
        specialtyName: this.speciality.specName,
        userId: this.userId
      };
      if (
        this.addName == "" ||
        this.addmobile == "" ||
        this.addpassword == "" ||
        this.addpassword2 == "" ||
        this.smsCode == "" ||
        this.speciality.specId == ""
      ) {
        this.$message({
          message: "请填写管理员全部信息",
          type: "error"
        });
      } else {
        addManagement(data)
          .then(res => {
            if (res.data.code == "00000") {
              this.$message({
                message: res.data.message,
                type: "success"
              });
              this.btn();
            } else {
              this.$message(res.data.message);
            }
            this.dialogVisible2 = false;
            this.hospitaManagement();
            this.addName = "";
            this.addmobile = "";
            this.addpassword = "";
            this.addpassword2 = "";
            this.smsCode = "";
            this.speciality = "";
            this.speciality = "";
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    // 发送验证码
    send() {
      if (this.addmobile == "") {
        this.$message("手机号码不能为空!");
      } else {
        getSmsCode2(this.addmobile)
          .then(res => {
            if (res.data.code == "00000") {
              console.log(res.data.message);
              let msg = res.data.message;
              this.$message({
                message: "验证码发送" + msg,
                type: "success"
              });
              // 倒计时
              this.Verification = false; //点击button改变v-show的状态
              this.auth_timer = setInterval(() => {
                //定时器设置每秒递减
                this.time--; //递减时间
                if (this.time <= 0) {
                  this.Verification = true; //60s时间结束还原v-show状态并清除定时器
                  clearInterval(this.auth_timer);
                  this.auth_timer = null;
                  this.time = 60;
                }
              }, 1000);
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    // 编辑管理人员
    updata(userId, cnName) {
      this.dialogVisible3 = true;
      this.editcnName = cnName;
      this.edituserId = userId;
    },
    updata1() {
      let data = {
        cnName: this.editcnName,
        userId: this.edituserId,
        password: this.editpassword2,
        specialtyName: this.speciality2.specName,
        specialtyId: this.speciality2.specId
      };
      console.log(data);
      if (
        this.editcnName == "" ||
        this.editpassword == "" ||
        this.editpassword2 == "" ||
        this.speciality2.specId == ""
      ) {
        this.$message({
          message: "请填写管理员全部信息",
          type: "error"
        });
      } else if (this.editpassword != this.editpassword2) {
        this.$message({
          message: "两次密码输入不一致",
          type: "error"
        });
      } else {
        editManagementmsg(data)
          .then(res => {
            if (res.data.code == "00000") {
              this.$message({
                message: res.data.message,
                type: "success"
              });
            } else {
              this.$message(res.data.message);
            }
            this.dialogVisible3 = false;
            this.hospitaManagement();
            this.btn();
            this.editcnName = "";
            this.editpassword = "";
            this.editpassword2 = "";
            this.speciality2 = "";
          })
          .catch(err => {
            console.log(err);
          });
      }
    }
  },
  mounted() {
    this.userId = Cookies.get("userid");
    this.hospitaManagement();
    this.btn();
    // 新增项目一级菜单选择
    getSpecialty(0)
      .then(res => {
        this.specialtylist = res.data.data;
        console.log(this.specialtylist);
      })
      .catch(err => {
        console.log(err);
      });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.menas {
  margin-top: 20px;
  margin-bottom: 20px;
}

.title {
  font-size: 16px;
  margin-bottom: 30px;
  font-weight: bold;
}

.sed-title {
  color: #999999;
  margin-right: 15px;
}

.edit {
  cursor: pointer;
}

.forms p {
  margin-bottom: 20px;
}

.el-button--text {
  color: #444444;
}

.el-row {
  line-height: 40px;
}

.codebtn {
  display: inline-block;
  width: 100px;
  height: 40px;
  line-height: 38px;
  text-align: center;
  border: 1px solid rgba(173, 204, 249, 1);
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.67);
  color: #3672bf;
  margin-left: 20px;
  font-weight: bold;
  cursor: pointer;
}

.code {
  margin-left: 15px;
}
</style>


// WEBPACK FOOTER //
// src/hospital/user-menas.vue